// externals
import React from 'react';
import { connect } from 'react-redux';
import type { RouteComponentProps } from 'react-router';

// libraries
import type { IRootProps } from '@makemydeal/dr-activities-tradein';
import { TRADE_IN } from '@makemydeal/dr-activities-tradein';
import type { StateTree } from '@makemydeal/dr-dash-types';
import { dealerSelectors } from '@makemydeal/dr-shared-store';

// config
import { getConfigTradeFromState, getTradeInSelectors } from '../config';

// components
import { TradeInUI } from './TradeInUI';

export const mapStateToProps = (state: StateTree, _ownProps: RouteComponentProps): IRootProps => {
    const selectors = getTradeInSelectors();
    const {
        checkIsSubaruGtpEligible,
        // getTradeInCurrentLocationRoute,
        // getTradeInCurrentLocationRouteForIco,
        icoTradeFlow,
        isICO,
        isShopperEnteredTrade,
        isTradeInCompleted,
        isTradeInIcoEnabled,
        getTradeDecisionPage,
        getManualTradeDecision
    } = selectors;

    const getRoute = () => {
        if (isTradeInCompleted(state)) {
            // click Edit on Trade-In card

            if (dealerSelectors.isSubaruGtpEnabled(state) && checkIsSubaruGtpEligible(state)) {
                return '/tradeSubaruEligibility';
            }

            if (isShopperEnteredTrade(state)) {
                return '/tradeInManualEntry';
            }

            if (isICO(state)) {
                return '/tradeInIco';
            }

            return '/vehicleInfo'; // default when Trade-In is completed
        }

        const icoIsOn = isTradeInIcoEnabled(state) && icoTradeFlow(state);

        if ((icoIsOn && getTradeDecisionPage(state)) || (getTradeDecisionPage(state) && getManualTradeDecision(state))) {
            return '/tradeInDecision';
        }

        if (icoIsOn) {
            // should show ICO page when Admin toggles for Decision page is disabled and ICO is enabled.
            return '/tradeInIco';
        }

        return '/tradeInSearch'; // default when Trade-In is not completed
    };

    const currentRoute = getRoute();

    const props: IRootProps = {
        baseRoute: TRADE_IN,
        config: {
            ...getConfigTradeFromState(state),
            userContext: {
                isDealer: true,
                isDesking: true
            }
        },
        selector: selectors,
        actionCreators: {},
        currentRoute
    };
    return props;
};

const connectWrapper = connect(mapStateToProps);
const connectedTradeInUi = connectWrapper(TradeInUI);

/**
 * `mapStateToProps` destructures `getTradeInSelectors()` unguarded, and those selectors only exist
 * once `configureTradeIn()` has run - which happens on BOOTSTRAP_SUCCESS, and only when the init
 * payload carries both `staticImages` and `services.gateway`. Rendering earlier throws.
 *
 * Guarding here rather than at each caller covers every entry point: the dashboard route mount and
 * the trade card's slide-out both go through this component.
 */
export const TradeInContainer = (props: RouteComponentProps) =>
    getTradeInSelectors() ? React.createElement(connectedTradeInUi, props) : null;
